export enum eDeleteFunnelProgressModal {
  HIDDEN = 'HIDDEN',
  PROGRESS = 'PROGRESS',
  SUCCESS = 'SUCCESS',
}
